import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08f836f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-input-wrapper" }
const _hoisted_2 = { class: "base-input__container" }
const _hoisted_3 = {
  key: 0,
  class: "base-input__start"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "base-input__error"
}

import { reactive, computed } from 'vue';
import { IonInput } from '@ionic/vue';

import { TextFieldTypes } from '@ionic/core';

interface Props {
  modelValue: string;
  slot?: string;
  errorMsg?: string;
  placeholder?: string;
  type?: TextFieldTypes;
  enableAutocomplete?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    modelValue: { default: '' },
    slot: { default: '' },
    errorMsg: { default: '' },
    placeholder: { default: '' },
    type: { default: 'text' },
    enableAutocomplete: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive({
  isShowPassword: false,
});

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
const inputType = computed(() => {
  if (props.type === 'password') {
    return state.isShowPassword ? 'text' : 'password';
  }
  return props.type;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$slots.start)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "start")
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonInput), _mergeProps({
        modelValue: localModelValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
        autocomplete: _ctx.enableAutocomplete ? undefined : 'new-password',
        placeholder: props.placeholder,
        label: "",
        type: inputType.value,
        class: [
          'base-input',
          {
            'base-input--icon-left': _ctx.$slots.start,
            'base-input--show-password-button': props.type === 'password',
          },
        ],
        "clear-on-edit": false
      }, _ctx.$attrs), null, 16, ["modelValue", "autocomplete", "placeholder", "type", "class"]),
      (props.type === 'password')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "base-input__show-password-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (state.isShowPassword = !state.isShowPassword))
          }, [
            _createElementVNode("img", {
              src: `/assets/icon/eye${
            state.isShowPassword ? '-off' : ''
          }-icon.svg`,
              alt: `${state.isShowPassword ? 'Hide' : 'Show'} password`
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ]),
    (props.errorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.errorMsg), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})